if (!customElements.get('pickup-availability')) {
  customElements.define('pickup-availability', class PickupAvailability extends HTMLElement {
    constructor() {
      super();

      if (!this.hasAttribute('available')) return;

      this.onClickRefreshList = this.onClickRefreshList.bind(this);
      this.fetchAvailability(this.dataset.variantId);

    }

    update(variant) {
      if (variant?.available) {
        this.fetchAvailability(variant.id);
      } else {
        this.removeAttribute('available');
        this.innerHTML = '';
      }
    }

    fetchAvailability(variantId) {
      let rootUrl = this.dataset.rootUrl;
      if (!rootUrl.endsWith('/')) {
        rootUrl = rootUrl + '/';
      }
      const variantSectionUrl = `${rootUrl}variants/${variantId}/?section_id=pickup-availability`;

      fetch(variantSectionUrl)
        .then(response => response.text())
        .then(text => {
          const sectionInnerHTML = new DOMParser()
            .parseFromString(text, 'text/html')
            .querySelector('.shopify-section');
          this.renderPreview(sectionInnerHTML);

        })
        .catch(e => {
          const button = this.querySelector('button');
          if (button) button.removeEventListener('click', this.onClickRefreshList);
          this.renderError();
        });
    }

    onClickRefreshList(evt) {
      this.fetchAvailability(this.dataset.variantId);
    }

    renderError() {
      this.innerHTML = '';

      const button = this.querySelector('button');
      if (button) button.addEventListener('click', this.onClickRefreshList);
    }

    renderPreview(sectionInnerHTML) {
      const drawer = document.querySelector('.pickup-availability-drawer');
      if (drawer) drawer.remove();
      const pickupAvailabilityInformation = sectionInnerHTML?.querySelector('.pickup-availability-information');
      if (!pickupAvailabilityInformation) {
        this.innerHTML = "";
        this.removeAttribute('available');
        return;
      }

      this.innerHTML = pickupAvailabilityInformation.innerHTML;
      this.setAttribute('available', '');

      const pickupAvailability = document.getElementById('Pickup-Availability');
      const sideAvailability = sectionInnerHTML.querySelector('.side-availability');
      if (pickupAvailability && sideAvailability) pickupAvailability.innerHTML = sideAvailability.innerHTML;

      const button = this.querySelector('button');
      if (button) button.addEventListener('click', (evt) => {
        let panel = document.getElementById('Pickup-Availability');
        if (!panel) return;
        if (OverlayManager.isOpen(panel)) {
          OverlayManager.close(panel);
        } else {
          OverlayManager.open(panel);
        }

        evt.preventDefault();
      });
    }
  });
}
